module.exports = __webpack_public_path__ + "static/media/skincare-prod3.1348137d.png";